import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faRocket, 
  faUtensils, 
  faStar, 
  faPaperPlane, 
  faBolt, 
  faComments,
  faBuilding,
  faBullhorn,
  faSearch,
  faFileLines,
  faUsers
} from '@fortawesome/free-solid-svg-icons';
import Auth from './Auth';
import AuthImage from './AuthImage';
import './auth.css';
import './authView.css';

const AuthView = ({ isSignUp, userType, isResetPassword }) => {
    const empresasData = [
      {
        text: 'Activa tu perfil empresa y atrae talentos calificados.',
        icon: faBuilding,
        color: '#fb5424'
      },
      {
        text: 'Publica ofertas y recibe candidatos ideales.',
        icon: faBullhorn,
        color: '#ff6b35'
      },
      {
        text: 'Explora el buscador de talento y encuentra perfiles claves.',
        icon: faSearch,
        color: '#fb5424'
      },
      {
        text: 'Recibe CVs y crea tu propia base de talentos.',
        icon: faFileLines,
        color: '#ff6b35'
      },
      {
        text: 'Chatea directamente con candidatos interesados.',
        icon: faComments,
        color: '#fb5424'
      },
      {
        text: 'Agrega usuarios para gestionar tu cuenta.',
        icon: faUsers,
        color: '#ff6b35'
      }
    ];

    const profesionalesData = [
      {
        text: 'Potencia tu perfil y consigue nuevas oportunidades.',
        icon: faRocket,
        color: '#fb5424'
      },
      {
        text: 'Postula a las mejores ofertas del sector gastronómico.',
        icon: faUtensils,
        color: '#ff6b35'
      },
      {
        text: 'Descubre los mejores lugares para trabajar y sus beneficios.',
        icon: faStar,
        color: '#fb5424'
      },
      {
        text: 'Envía tu CV a empresas, incluso sin una oferta activa.',
        icon: faPaperPlane,
        color: '#ff6b35'
      },
      {
        text: 'Activa tu disponibilidad y cubre reemplazos.',
        icon: faBolt,
        color: '#fb5424'
      },
      {
        text: 'Chatea directamente con reclutadores.',
        icon: faComments,
        color: '#ff6b35'
      }
    ];

    const benefits = userType === 'empresas' ? empresasData : profesionalesData;

    return (
      <div>
        <div className='auth-view__container'>
          <div className='auth-view__benefit-copy-container'>
            <div className="auth-view__title-container">
              <h1 id="auth-view__title-container__title">Únete</h1>
              <h1> a la mayor red laboral gastronómica de Chile</h1>
            </div>
            <div className="auth-view__benefits-container-auth">
              <div className="auth-view__benefits-container">
                {benefits.map((benefit, index) => (
                   <div 
                     className="auth-view__benefit-container" 
                     key={index}
                     style={{ '--accent-color': benefit.color }}
                   >
                     <div className="benefit-icon">
                       <FontAwesomeIcon icon={benefit.icon} />
                     </div>
                     <h2>{benefit.text}</h2>
                   </div>
                ))}
              </div>
              <Auth isSignUp={isSignUp} userType={userType}/>
            </div>
          </div>
        </div>
      </div>
    );
};

export default AuthView;
